<template>
  <section class="_md:h-screen flex pb-16 w-full items-center bg-[url('../../assets/images/cta.jpg')] bg-center bg-no-repeat">
    <div class="container">
      <div class="lg:flex justify-center mt-12">
        <div class="lg:w-11/12 bg-white dark:bg-slate-900 rounded-md shadow-lg dark:shadow-gray-800 overflow-hidden">
          <div class="grid md:grid-cols-12 grid-cols-1 items-center">
            <div class="lg:col-span-7 md:col-span-6">
              <div class="w-full leading-[0] border-0">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15860.621429650153!2d2.454842547677277!3d6.3739354978597556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sbj!4v1696892193010!5m2!1sfr!2sbj" width="600" height="450" style="border: 0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>

            <div class="lg:col-span-5 md:col-span-6">
              <div class="p-6">
                <h3 class="mb-6 text-2xl leading-normal font-medium">Nos contacts</h3>

                <div class="flex items-center mt-6">
                  <i data-feather="mail" class="w-6 h-6 mr-4"></i>
                  <div class="">
                    <h5 class="title font-bold mb-0">Email</h5>
                    <a href="mailto:contact@celeriteholding.com" class="btn btn-link text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">{{ contact.email }}</a>
                  </div>
                </div>

                <div class="flex items-center mt-6">
                  <i data-feather="phone" class="w-6 h-6 mr-4"></i>
                  <div class="">
                    <h5 class="title font-bold mb-0">Téléphone</h5>
                    <a href="tel:+152534-468-854" class="btn btn-link text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">{{ contact.tel }}</a>
                  </div>
                </div>

                <ul class="list-none mt-6">
                  <li class="inline px-2">
                    <a href="https://www.facebook.com/celeriteholding" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 hover:text-white hover:bg-indigo-600"><i class="uil uil-facebook-f"></i></a>
                  </li>
                  <li class="inline px-2">
                    <a href="https://www.facebook.com/celeriteholding" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 hover:text-white hover:bg-indigo-600"><i class="uil uil-twitter"></i></a>
                  </li>
                  <li class="inline px-2">
                    <a href="https://bj.linkedin.com/company/celeriteholding" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 hover:text-white hover:bg-indigo-600"><i class="uil uil-linkedin"></i></a>
                  </li>
                </ul>
                <!--end icon-->
              </div>
              <div class="flex justify-center text-center p-6 border-t border-gray-100 dark:border-gray-800">
                <p class="mb-0 text-slate-400">© {{ currentDate }} BSD<i class="mdi mdi-heart text-red-600"></i></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end grid-->
    </div>
    <!--end container-->
  </section>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date().getFullYear(),
      contact: {
        tel: "+229 567 777 79",
        email: "contact@bsdfeedback.com",
      },
    };
  },
};
</script>

<style></style>
